<template>
    <div class="menu-container">
        <div class="menu-container__profile-img"> {{ namePrefix }} </div>
        <div class="menu-container__account">Account dashboard</div>
        <div class="menu-container__links">
          <div v-for="item in items"
               :key="item.path"
               class="menu-container__links__item"
          >
              <router-link :to="item.path"> {{ item.label }} </router-link>
          </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "SideBarMenu",
  data() {
    return {
      items: [
          { label: 'General', path: '/profile' },
          { label: 'Exchanges', path: '/profile/exchanges' },
          { label: 'Security', path: '/profile/security' },
      ]
    }
  },
  props: {
    namePrefix: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-container {
  box-shadow: 0.625px 0.0625rem 0.625rem rgb(0 0 0 / 30%);
  height: calc(100% - 4rem);
  width: 13rem;
  padding: 2rem;

  &__profile-img {
    height: 5rem;
    width: 5rem;
    line-height: 5rem;
    background-color: blueviolet;
    color: white;
    text-align: center;
    border-radius: 50%;
    font-weight: 700;
    font-size: 1.7rem;
    text-transform: uppercase;
  }


  &__account {
    font-style: normal;
    font-weight: 600;
    font-size: 1.1rem;
    margin-top: 1rem;
    text-align: left;
  }

  &__links {
    margin-top: 5.25rem;
    font-weight: 700;
    font-size: 1rem;
    line-height: 1rem;

    &__item {
      width: fit-content;

      &:not(:first-child) {
        margin-top: 2rem;
      }

      a {
        color: black;
        text-decoration: none;
        text-align: left;
      }

      .router-link-exact-active.router-link-active {
        color: blueviolet;
      }

    }
  }

}

// only mobile
@media (max-width: 768px) {
  .menu-container {
    padding-top: 4rem;
  }
}
</style>